export default function AdminPlaceholder({ label }) {
  return (
    <div data-testid={`admin-placeholder-${label.toLowerCase().replace(/\s+/g, "-")}`}>
      <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#ff1493]">// {label}</div>
      <h2 className="mt-2 font-display text-2xl md:text-4xl tracking-tight">{label}</h2>
      <div className="mt-8 border border-[#2a1a3a] p-8">
        <div className="font-mono text-[11px] tracking-[0.2em] uppercase text-[#7a6a90]">
          // module status: placeholder
        </div>
        <p className="mt-3 text-[#b4a3c7] leading-relaxed">
          This dashboard section is reserved for Phase 2. Build connections to the catalog,
          fulfillment, and inventory pipeline will land here.
        </p>
      </div>
    </div>
  );
}
